<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form :model="queryParams" ref="queryForm" size="small" label-width="100px">
          <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="使用单位">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="设备识别码">
                <el-input v-model="queryParams.oidno" placeholder="请输入设备识别码" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="到检年月" prop="inspectionMonthList">
                <el-date-picker v-model="queryParams.inspectionMonthList" type="months" value-format="yyyy-MM" placeholder="请选择到检年月" clearable style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="客户名称">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" clearable @keyup.enter.native="handleQuery" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="状态">
                <el-select v-model="queryParams.reportState" placeholder="请选择状态" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="全部" value="" />
                  <el-option label="待整改" value="待整改" />
                  <el-option label="待提交" value="待提交" />
                  <el-option label="待审核" value="待审核" />
                  <el-option label="待签发" value="待签发" />
                  <el-option label="已签发" value="已签发" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="24" type="flex">
            <el-col :span="6">
              <el-form-item label="检测日期">
                <el-date-picker v-model="queryParams.testDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                                style="width: 100%;" />
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :gutter="24" type="flex">

            <el-col :span="5">
              <el-form-item label="批量提交时间">
                <el-date-picker v-model="queryParams.submitTimeRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                                style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="审核日期">
                <el-date-picker v-model="queryParams.auditDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                                style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="签发日期">
                <el-date-picker v-model="queryParams.approveDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                                style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="检测人">
                <el-input v-model="queryParams.testEmployeeName" placeholder="请输入检测人" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="小区名称">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="产品编号">
                <el-input v-model="queryParams.factoryCod" placeholder="请输入产品编号" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="区域">
                <ChinaAreaCascader :multiple="true" :checkStrictly="true" width="100%" v-model="areaSelectedValue" />
              </el-form-item>
            </el-col>
          </el-row>

          <div style="text-align: center; margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleQuery="handleQuery" @exportMemoToExcel="exportMemoToExcel" @BatchDeleteFiles="BatchDeleteFiles"/>
          </div>

          <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" v-loading="loading"
                    element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" row-key="entrustNum"
                    @selection-change="handleSelectionChange" height="500">
            <el-table-column type="selection" width="55" fixed="left" align="left"></el-table-column>
            <el-table-column type="index" label="序号" width="60" align="left" :index="indexMethod"></el-table-column>
            <el-table-column label="检测日期" align="left" prop="testEmployeeDate" min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" align="left" prop="reportState" min-width="100" show-overflow-tooltip>
              <!-- <template slot-scope="scope">
                <el-tag :type="getReportStateType(scope.row.reportState)">
                  {{ getReportStateText(scope.row.reportState) }}
                </el-tag>
              </template> -->
            </el-table-column>
            <el-table-column label="监管上传状态" align="left" prop="ispinfoSubmitState" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ getSupervisionStatusText(scope.row.ispinfoSubmitState) }}
              </template>
            </el-table-column>
            <el-table-column label="小区名称" align="left" prop="houseName" min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column label="设备识别码" align="left" prop="oidno" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="检测人" align="left" prop="testEmployeeName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="提交时间" align="left" prop="submitTime" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="审核日期" align="left" prop="auditDate" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="签发日期" align="left" prop="approveDate" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="到检年月" align="left" prop="inspectionMonth" min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column label="视频是否上传" align="left" prop="videoUploaded" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ getVideoUploadStatusText(scope.row.videoUploaded) }}
              </template>
            </el-table-column>
            <el-table-column label="视频大小" align="left" prop="videoSize" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatVideoSize(scope.row.videoSize) }}
              </template>
            </el-table-column>
            <el-table-column label="设备名称" align="left" prop="eqpTempName" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="产品编号" align="left" prop="factoryCod" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="认领日期" align="left" prop="claimDate" min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column label="审核人" align="left" prop="auditEmployeeName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="签发人" align="left" prop="approveEmployeeName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="left" width="480" fixed="right">
              <template slot-scope="scope">
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleViewSingle="handleViewSingle(scope.row)" @handlePDF="handlePDF(scope.row)" @handleMemoDetail="handleMemoDetail(scope.row)"
                                     @handleRectificationDetail="handleRectificationDetail(scope.row)" @handleConformanceDetail="handleConformanceDetail(scope.row)"
                                     @exportViewSingle="exportViewSingle(scope.row)" />
              </template>
            </el-table-column>
          </el-table>

          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                         :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;" />
        </el-form>
      </el-col>
    </el-row>

    <el-dialog title="预览" :visible.sync="pdfPreviewVisible" width="80%" append-to-body>
      <PdfImgViewer ref="pdfImgViewer" :fileName="pdfFileName" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="pdfPreviewVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="视频播放" :visible.sync="videoDialogVisible" width="800px" :before-close="closeVideoDialog" :close-on-click-modal="false">
      <div class="video-container">
        <video v-if="currentVideoUrl" ref="videoPlayer" :src="currentVideoUrl" controls width="100%" style="max-height: 500px;">
          您的浏览器不支持视频播放
        </video>
        <div v-else class="no-video">
          <i class="el-icon-video-camera" style="font-size: 48px; color: #ccc;"></i>
          <p style="color: #999; margin-top: 10px;">暂无视频</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeVideoDialog">关 闭</el-button>
      </span>
    </el-dialog>

    <Rectification ref="rectificationDialog" />
  </div>
</template>

<script>
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue';
import Rectification from '../rectificationItem/rectification.vue';
import { queryComprehensiveReportList, previewTestDataPdf, regenerateMemoPdf, downloadComprehensivePdf, deleteLocalPdf } from '@/api/contract/contract';
import ChinaAreaCascader from '@/components/ChinaAreaCascader/index.vue';
export default {
  name: 'ComprehensiveReport',
  components: {
    PdfImgViewer,
    Rectification,
    ChinaAreaCascader
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableData: [],
      selectedRows: [],
      loading: false,
      total: 0,
      pdfPreviewVisible: false,
      pdfFileName: '',
      videoDialogVisible: false,
      currentVideoUrl: '',
      queryParams: {
        currPage: 1,
        pageSize: 200,
        usingUnit: undefined,
        oidno: undefined,
        inspectionMonthList: [],
        reportState: undefined,
        compNames: undefined,
        testDateRange: [],
        houseName: undefined,
        submitTimeRange: [],
        auditDateRange: [],
        approveDateRange: []
      },
      areaSelectedValue: [], // ChinaAreaCascader 多选值
    };
  },
  created () {
    // this.getList();
  },
  watch: {
    areaSelectedValue (newVal) {
      this.handleAreaChange(newVal)
    }
  },
  methods: {
    // 处理区域选择变化
    handleAreaChange (value) {
      // ChinaAreaCascader 多选时返回字符串数组，例如 ['福建省/福州市/仓山区/上街镇']
      if (!Array.isArray(value) || value.length === 0) {
        this.queryParams.EQP_AREA_NAME = ''
        return
      }
      this.queryParams.EQP_AREA_NAME = value.join(',')
    },
    // 计算表格序号（按分页连续编号）
    indexMethod (index) {
      return (this.queryParams.currPage - 1) * this.queryParams.pageSize + index + 1;
    },
    // 报告状态值转中文显示
    getReportStateText (status) {
      switch (status) {
        case 'Audit':
          return '审核';
        case 'Approval':
          return '签发';
        case 'Test':
          return '检测';
        case 'Check':
          return '待提交';
        default:
          return status || '未知';
      }
    },
    // 报告状态转标签类型
    getReportStateType (status) {
      switch (status) {
        case 'Audit':
          return 'warning';
        case 'Approval':
          return 'success';
        default:
          return 'info';
      }
    },
    // 视频上传状态值转中文显示
    getVideoUploadStatusText (status) {
      const value = String(status);
      switch (value) {
        case '0':
          return '上传中';
        case '1':
          return '已完成';
        case '2':
          return '上传失败';
        case '3':
          return '文件合并中';
        case '4':
          return 'NAS同步中';
        case '5':
          return '未上传';
        default:
          return '-';
      }
    },
    // 监管上传状态值转中文显示
    getSupervisionStatusText (status) {
      const value = String(status);
      switch (value) {
        case '0':
          return '已上传';
        case '1':
          return '未上传';
        case '2':
          return '上传失败';
        default:
          return '-';
      }
    },
    // 格式化视频大小展示
    formatVideoSize (size) {
      if (size === null || size === undefined || size === '' || size === 0) {
        return '-';
      }
      const num = Number(size);
      if (Number.isNaN(num)) {
        return '-';
      }
      // 将字节转换为 MB
      return `${(num / 1024 / 1024).toFixed(2)} MB`;
    },
    // 查询综合报告列表
    getList () {
      this.loading = true;
      queryComprehensiveReportList(this.queryParams).then(res => {
        if (res && res.retCode === 'ok' && res.additionalData) {
          const { records = [], current = this.queryParams.currPage, size = this.queryParams.pageSize, total = 0 } = res.additionalData || {};
          this.tableData = records;
          this.queryParams.currPage = current;
          this.queryParams.pageSize = size;
          this.total = total;
        } else {
          this.$message.error((res && res.retMsg) || '获取综合报告列表失败');
        }
        this.loading = false;
      }).catch(error => {
        console.error('获取综合报告列表失败:', error);
        this.loading = false;
        this.$message.error('获取综合报告列表失败');
      });
    },
    // 点击查询：重置到第一页并查询
    handleQuery () {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 分页大小变更后重新查询
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 切换页码后重新查询
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    },
    // 查看单条视频
    handleViewSingle (row) {
      if (!row.videoFileUrl) {
        this.$message.warning('该记录暂无视频文件');
        return;
      }
      this.currentVideoUrl = row.videoFileUrl;
      this.videoDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.play().catch(error => {
            console.error('自动播放失败:', error);
          });
        }
      });
    },
    // 记录/报告查看入口
    handlePDF (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('缺少委托编号');
        return;
      }
      this.$confirm('请选择要查看的内容：', '选择打印类型', {
        distinguishCancelAndClose: true,
        confirmButtonText: '原始记录',
        cancelButtonText: '报告',
        type: 'info'
      }).then(() => {
        this.callPreviewAPI(row.entrustNum, 1);
      }).catch(action => {
        if (action === 'cancel') {
          this.callPreviewAPI(row.entrustNum, 0);
        }
      });
    },
    // 调用后端生成并预览PDF
    callPreviewAPI (entrustNum, type) {
      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      previewTestDataPdf({ entrustNums: [entrustNum], type: type }).then(response => {
        loading.close();
        if (response && response.retCode === 'ok' && response.additionalData) {
          this.pdfFileName = response.additionalData + '.pdf';
          this.pdfPreviewVisible = true;
          this.$nextTick(() => {
            if (this.$refs.pdfImgViewer) {
              this.$refs.pdfImgViewer.init();
            }
          });
          this.$message.success('PDF生成成功');
        } else {
          this.$message.error(response.retMsg || 'PDF生成失败');
        }
      }).catch(error => {
        console.error('查看PDF失败:', error);
        loading.close();
        this.$message.error('查看PDF失败');
      });
    },
    // 预览备忘录 PDF：后端校验库记录与磁盘文件，不存在则补生成
    handleMemoDetail (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('缺少委托编号');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '正在加载备忘录PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      regenerateMemoPdf({ entrustNum: row.entrustNum }).then(response => {
        loading.close();
        if (response && response.retCode === 'ok' && response.additionalData) {
          const pdfFileName = response.additionalData + '.pdf';
          row.memoFileUUID = pdfFileName;
          this.openMemoPdfPreview(pdfFileName);
          if (response.retMsg !== 'PDF已存在') {
            this.$message.success(response.retMsg || '备忘录PDF生成成功');
          }
        } else {
          this.$message.error(response.retMsg || '备忘录PDF生成失败');
        }
      }).catch(error => {
        console.error('查看备忘录PDF失败:', error);
        loading.close();
        this.$message.error('查看备忘录PDF失败');
      });
    },
    openMemoPdfPreview (fileName) {
      this.pdfFileName = fileName;
      this.pdfPreviewVisible = true;
      this.$nextTick(() => {
        if (this.$refs.pdfImgViewer) {
          this.$refs.pdfImgViewer.init();
        }
      });
    },
    // 打开整改详情弹窗（只读）
    handleRectificationDetail (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('委托单编号不能为空');
        return;
      }
      this.$refs.rectificationDialog && this.$refs.rectificationDialog.openDialog(row, { mode: 'view'});
    },
    // 查看符合性声明PDF
    handleConformanceDetail (row) {
      if (!row.conformanceFileUUID) {
        this.$message.warning('文件不存在');
        return;
      }
      this.pdfFileName = row.conformanceFileUUID;
      this.pdfPreviewVisible = true;
      this.$nextTick(() => {
        if (this.$refs.pdfImgViewer) {
          this.$refs.pdfImgViewer.init();
        }
      });
    },
    // 关闭视频弹窗并重置播放器
    closeVideoDialog () {
      this.videoDialogVisible = false;
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.pause();
          this.$refs.videoPlayer.currentTime = 0;
        }
        this.currentVideoUrl = '';
      });
    },
    // 表格勾选变更
    handleSelectionChange (rows) {
      this.selectedRows = rows || [];
    },
    // 从 Content-Disposition 响应头中解析文件名
    getFileNameFromDisposition (disposition) {
      if (!disposition) return '';

      const utf8Match = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
      if (utf8Match && utf8Match[1]) {
        try {
          return decodeURIComponent(utf8Match[1].replace(/(^\"|\"$)/g, '').trim());
        } catch (e) {
          return utf8Match[1].replace(/(^\"|\"$)/g, '').trim();
        }
      }

      const normalMatch = disposition.match(/filename\s*=\s*([^;]+)/i);
      if (normalMatch && normalMatch[1]) {
        let name = normalMatch[1].trim();
        name = name.replace(/(^\"|\"$)/g, '');
        try {
          return decodeURIComponent(name);
        } catch (e) {
          return name;
        }
      }

      return '';
    },
    // 备忘录批量下载
    exportMemoToExcel () {
      if (!this.selectedRows.length) {
        this.$message.warning('请先勾选需要下载的数据');
        return;
      }

      const entrustNums = [...new Set(this.selectedRows.map(row => row.entrustNum).filter(Boolean))];
      if (!entrustNums.length) {
        this.$message.warning('勾选数据中未找到委托编号，无法下载');
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: '正在下载备忘录，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      downloadComprehensivePdf({ entrustNums }).then(response => {
        loading.close();
        const blob = (response && response.data instanceof Blob)
          ? response.data
          : new Blob([response], { type: 'application/zip' });

        if (blob && blob.type && blob.type.includes('application/json')) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorData = JSON.parse(reader.result);
              this.$message.error(errorData.retMsg || errorData.message || '下载失败');
            } catch (e) {
              this.$message.error('下载失败');
            }
          };
          reader.readAsText(blob);
          return;
        }

        if (!blob || blob.size === 0) {
          this.$message.error('下载失败：未获取到文件');
          return;
        }

        const disposition = response && response.headers
          ? (response.headers['content-disposition'] || response.headers['Content-Disposition'])
          : '';
        const fileName = this.getFileNameFromDisposition(disposition) || '备忘录.zip';
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        this.$message.success('备忘录下载成功');
      }).catch(error => {
        loading.close();
        console.error('备忘录下载失败:', error);
        this.$message.error('备忘录下载失败');
      });
    },
    // 单条视频下载（跨域文件不可 fetch，需直接触发浏览器下载）
    exportViewSingle (row) {
      if (!row || !row.videoFileUrl) {
        this.$message.warning('该记录暂无视频文件');
        return;
      }

      const sanitizeFileName = (name) => (name || '').replace(/[\\/:*?"<>|]/g, '');
      const urlExtMatch = row.videoFileUrl.match(/\.([a-zA-Z0-9]+)(?:\?|$)/);
      const ext = urlExtMatch ? urlExtMatch[1] : 'mp4';
      const fileName = `${sanitizeFileName(row.oidno)}${sanitizeFileName(row.usingUnit)}.${ext}`;

      try {
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = row.videoFileUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message.success('视频下载已开始');
      } catch (error) {
        console.error('视频下载失败:', error);
        this.$message.error('视频下载失败');
      }
    },
    // 批量删除有问题的本地PDF文件
    BatchDeleteFiles () {
      if (!this.selectedRows.length) {
        this.$message.warning('请先勾选需要删除的数据');
        return;
      }

      const entrustNums = [...new Set(this.selectedRows.map(row => row.entrustNum).filter(Boolean))];
      if (!entrustNums.length) {
        this.$message.warning('勾选数据中未找到委托编号，无法删除');
        return;
      }

      const oidnoList = [...new Set(this.selectedRows.map(row => row.oidno).filter(Boolean))];
      const fileListText = oidnoList.join('<br/>');
      this.$confirm(
        `是否删除以下文件？<br/><div style="max-height: 240px; overflow: auto; margin-top: 8px; word-break: break-all; line-height: 1.6;">${fileListText}</div>`,
        '确认删除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在删除文件，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        deleteLocalPdf({ entrustNums }).then(res => {
          loading.close();
          if (res && res.retCode === 'ok') {
            this.$message.success(res.retMsg || '删除成功');
            this.getList();
          } else {
            this.$message.error((res && res.retMsg) || '删除失败');
          }
        }).catch(error => {
          loading.close();
          console.error('批量删除文件失败:', error);
          this.$message.error('批量删除文件失败');
        });
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}
.video-container {
  text-align: center;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.no-video {
  text-align: center;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
